import { useEffect, useState, useContext } from 'react';
import { ReactComponent as Bankdetails } from "../../../Assets/Images/bankDetails.svg";
import { ReactComponent as Delete } from "../../../Assets/Images/delete-icon.svg";
import { regex } from '../../../utils/constants';
import {
  deleteBankUpi,
  getUserDetail,
  saveBankData,
  upiVerify,
  saveUpiTransaction
} from '../../../Services/action';
import { useNavigate } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AppTracking from "../../../Components/appTracking";
import { DataContext } from '../../../Components/DataContext.js';

const UPIDetails = () => {
  const navigate = useNavigate();
  const { data, setData } = useContext(DataContext);
  const newData = { ...data };
  const mobileNum = newData.mobileNumber;
  const [upi, setUpi] = useState('');
  const [resultUpi, setResultUpi] = useState(false);
  const [upiError, setUpiError] = useState('');
  const [userDetails, setUserDetails] = useState([]);
  const [savePayment, setSavePayment] = useState(false);
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalWarning, setIsModalWarning] = useState(false);
  const [isModalWarningYesNo, setIsModalWarningYesNo] = useState(false);
  const [userInfo, setUserDetailsBankMsg] = useState('');
  const [loader, setLoader] = useState(false);
  const [modal, setModal] = useState('');
  const [loaderTrans, setLoaderTrans] = useState(false);
  const [accountIsMax, setAccountIsMax] = useState('');

  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    return 'unknown';
  };

  const handleSubmit = () => {
    setLoaderTrans(true);

    saveBankData({
      mobileNo: mobileNum,
      name: '',
      ifsc: '',
      paymentMode: 'upi',
      bankName: '',
      branchName: ' ',
      accountNo: '',
      upiId: upi

    }, newData.token)
      .then((data) => {
        if (data.statusMsg.code === 0) {

          let bankUpiId = data.data.bankUpiId;

          navigator.permissions.query({ name: 'geolocation' }).then((result) => {
            if (result.state === 'granted') {
              // Permission was granted
              navigator.geolocation.getCurrentPosition(function (position) {
                let latitude = position.coords.latitude;
                let longitude = position.coords.longitude;

                if (userDetails == "") {
                  upiVerify({
                    "mobileNo": mobileNum,
                    "userUpiMappingId": bankUpiId,
                    "couponCode": newData.couponCode,
                    "couponVal": newData.scanVal,
                    "payeeVPA": 'elwin@scb'

                  }, newData.token)
                    .then((data) => {
                      if (data.statusMsg.code === 0) {
                        if (latitude != null && longitude != null) {
                          saveUpiTransaction({
                            "mobileNo": mobileNum,
                            "userBankMappingId": "",
                            "userUpiMappingId": bankUpiId,
                            "couponCode": newData.couponCode,
                            "couponVal": newData.scanVal,
                            "transactionState": "start",
                            "transId": "",
                            "payeeVPA": 'elwin@scb',
                            "latitude": String(latitude),
                            "longitude": String(longitude),
                            "state": "",
                            "city": "",
                            "pincode": 0
                          }, newData.token)
                            .then((data) => {
                              if (data.statusMsg.code === 0) {
                                setUpi('');
                                setLoaderTrans(false);
                                newData.transactionStatus = true;
                                setData(newData);
                                navigate('/amountCredited');
                              }
                              else if (data.statusMsg.code === 1) {
                                setModal(data.statusMsg.msg);
                                setIsModalWarning(true);
                                setUpi('');
                                setLoaderTrans(false);
                              }
                              else if (data.statusMsg.code === -1) {
                                setModal(data.statusMsg.msg);
                                setIsModalError(true);
                                setUpi('');

                                setLoaderTrans(false);
                              }
                            }).catch((error) => {
                              setLoaderTrans(false);
                            });
                        }
                        else {
                          setLoader(false);
                        }
                      }
                      else if (data.statusMsg.code === 1) {
                        setModal(data.statusMsg.msg);
                        setIsModalWarning(true);
                        setUpi('');
                        setLoaderTrans(false);
                      }
                      else if (data.statusMsg.code === -1) {
                        setModal(data.statusMsg.msg);
                        setIsModalError(true);
                        setUpi('');
                        setLoaderTrans(false);
                      }
                    }).catch((error) => {
                      setLoaderTrans(false);
                    });
                }
                else {
                  if (latitude != null && longitude != null) {
                    saveUpiTransaction({
                      "mobileNo": mobileNum,
                      "userBankMappingId": "",
                      "userUpiMappingId": bankUpiId,
                      "couponCode": newData.couponCode,
                      "couponVal": newData.scanVal,
                      "transactionState": "start",
                      "transId": "",
                      "payeeVPA": 'elwin@scb',
                      "latitude": String(latitude),
                      "longitude": String(longitude),
                      "state": "",
                      "city": "",
                      "pincode": 0
                    }, newData.token)
                      .then((data) => {
                        if (data.statusMsg.code === 0) {
                          setUpi('');
                          setLoaderTrans(false);
                          newData.transactionStatus = true;
                          setData(newData);
                          navigate('/amountCredited');
                        }
                        else if (data.statusMsg.code === 1) {
                          setModal(data.statusMsg.msg);
                          setIsModalWarning(true);
                          setUpi('');
                          setLoaderTrans(false);
                        }
                        else if (data.statusMsg.code === -1) {
                          setModal(data.statusMsg.msg);
                          setIsModalError(true);
                          setUpi('');
                          setLoaderTrans(false);
                        }
                      }).catch((error) => {
                        setLoaderTrans(false);
                      });
                  }
                  else {
                    setLoaderTrans(false);
                    if (getMobileOperatingSystem() == 'Android') {
                      setModal("We couldn't find your location.Please allow from settings to proceed further.");
                    }
                    else {
                      setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
                    }
                    setIsModalWarning(true);
                  }
                }
              })
            }
            else if (result.state === 'denied') {
              setLoaderTrans(false);
              if (getMobileOperatingSystem() == 'Android') {
                setModal("We couldn't find your location.Please allow from settings to proceed further.");
              }
              else {
                setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
              }
              setIsModalWarning(true);
            }
            else if (result.state === 'prompt') {
              navigator.geolocation.getCurrentPosition(function (position) {
                let latitude = position.coords.latitude;
                let longitude = position.coords.longitude;
                if (userDetails == "") {
                  upiVerify({
                    "mobileNo": mobileNum,
                    "userUpiMappingId": bankUpiId,
                    "couponCode": newData.couponCode,
                    "couponVal": newData.scanVal,
                    "payeeVPA": 'elwin@scb'
                  }, newData.token)
                    .then((data) => {
                      if (data.statusMsg.code === 0) {
                        if (latitude != null && longitude != null) {
                          saveUpiTransaction({
                            "mobileNo": mobileNum,
                            "userBankMappingId": "",
                            "userUpiMappingId": bankUpiId,
                            "couponCode": newData.couponCode,
                            "couponVal": newData.scanVal,
                            "transactionState": "start",
                            "transId": "",
                            "payeeVPA": 'elwin@scb',
                            "latitude": String(latitude),
                            "longitude": String(longitude),
                            "state": "",
                            "city": "",
                            "pincode": 0,

                          }, newData.token)
                            .then((data) => {
                              if (data.statusMsg.code === 0) {
                                setUpi('');
                                setLoaderTrans(false);
                                newData.transactionStatus = true;
                                setData(newData);
                                navigate('/amountCredited');
                              }
                              else if (data.statusMsg.code === 1) {
                                setModal(data.statusMsg.msg);
                                setIsModalWarning(true);
                                setUpi('');
                                setLoaderTrans(false);
                              }
                              else if (data.statusMsg.code === -1) {
                                setModal(data.statusMsg.msg);
                                setIsModalError(true);
                                setUpi('');

                                setLoaderTrans(false);
                              }
                            }).catch((error) => {
                              setLoaderTrans(false);
                            });
                        }
                        else {
                          setLoaderTrans(false);
                        }
                      }
                      else if (data.statusMsg.code === 1) {
                        setModal(data.statusMsg.msg);
                        setIsModalWarning(true);
                        setUpi('');
                        setLoaderTrans(false);
                      }
                      else if (data.statusMsg.code === -1) {
                        setModal(data.statusMsg.msg);
                        setIsModalError(true);
                        setUpi('');

                        setLoaderTrans(false);
                      }
                    }).catch((error) => {
                      setLoaderTrans(false);
                    });
                }
                else {
                  if (latitude != null && longitude != null) {
                    saveUpiTransaction({
                      "mobileNo": mobileNum,
                      "userBankMappingId": "",
                      "userUpiMappingId": bankUpiId,
                      "couponCode": newData.couponCode,
                      "couponVal": newData.scanVal,
                      "transactionState": "start",
                      "transId": "",
                      "payeeVPA": 'elwin@scb',
                      "latitude": String(latitude),
                      "longitude": String(longitude),
                      "state": "",
                      "city": "",
                      "pincode": 0
                    }, newData.token)
                      .then((data) => {
                        if (data.statusMsg.code === 0) {
                          setUpi('');
                          setLoaderTrans(false);
                          newData.transactionStatus = true;
                          setData(newData);
                          navigate('/amountCredited');
                        }
                        else if (data.statusMsg.code === 1) {
                          setModal(data.statusMsg.msg);
                          setIsModalWarning(true);
                          setUpi('');
                          setLoaderTrans(false);
                        }
                        else if (data.statusMsg.code === -1) {
                          setModal(data.statusMsg.msg);
                          setIsModalError(true);
                          setUpi('');
                          setLoaderTrans(false);
                        }
                      }).catch((error) => {
                        setLoaderTrans(false);
                      });
                  }
                  else {
                    setLoaderTrans(false);
                    if (getMobileOperatingSystem() == 'Android') {
                      setModal("We couldn't find your location.Please allow from settings to proceed further.");
                    }
                    else {
                      setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
                    }
                    setIsModalWarning(true);
                  }
                }
              },
                (error) => {
                  if (error.code === error.PERMISSION_DENIED) {
                    setLoaderTrans(false);
                    if (getMobileOperatingSystem() == 'Android') {
                      setModal("We couldn't find your location.Please allow from settings to proceed further.");
                    }
                    else {
                      setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
                    }
                    setIsModalWarning(true);
                    console.error('User denied the request for Geolocation.');
                    // Handle permission denied
                  } else {
                    setLoaderTrans(false);
                    if (getMobileOperatingSystem() == 'Android') {
                      setModal("We couldn't find your location.Please allow from settings to proceed further.");
                    }
                    else {
                      setModal("Seems you are not an Android user, it is recommended to scan the coupon again after enabling location services.");
                    }
                    setIsModalWarning(true);
                    console.error('Error getting position:', error);
                    // Handle other errors
                  }
                })
            }
          });
        }
        else if (data.statusMsg.code === 1) {
          setModal(data.statusMsg.msg);
          setIsModalWarning(true);
          setUpi('');
          setLoaderTrans(false);
        }
        else if (data.statusMsg.code === -1) {
          setModal(data.statusMsg.msg);
          setIsModalError(true);
          setUpi('');
          setLoaderTrans(false);
        }
      }).catch((error) => {
        setLoaderTrans(false);
      });
  };
  const handleChangeUpi = (event) => {
    setUpi(event.target.value.replace(/[^a-zA-Z0-9@\-_\.]/g, ''));
    let pattern = regex.upiIdRegex;
    let resUpi = pattern.test(event.target.value.replace(/[^a-zA-Z0-9@\-_\.]/g, ''));
    setResultUpi(resUpi);
    if (!resUpi) {
      setUpiError("Please enter valid/active UPI ID")
    }
  }
  const getUserInfo = () => {
    setLoader(true);
    getUserDetail(mobileNum, newData.couponCode, newData.token)
      .then((data) => {
        setUserDetailsBankMsg(data.data.upiIdMsg);
        setAccountIsMax(data.data.maxAcReached);

        if (data.data.upiDetails) {
          const upiDetailed = JSON.parse(data.data.upiDetails);
          setUserDetails(upiDetailed);
          setUpi(upiDetailed[0].UPI_ID)
          let pattern = regex.upiIdRegex;
          let resUpi = pattern.test(upiDetailed[0].UPI_ID);
          setResultUpi(resUpi);
          setLoader(false);
        }
        else {
          setUserDetails([]);
          setUpi('');
          setResultUpi(false);
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
      });
  };
  const handleClose = (type) => {
    if (type === 1) {
      setIsModalSuccess(false);
    }
    else if (type === 2) {
      setIsModalError(false);
    }
    else if (type === 3) {
      setIsModalWarning(false);
    }
    else if (type === 4) {
      setIsModalWarningYesNo(false);
    }
    getUserInfo();
  }
  const deleteAccount = () => {
    if (accountIsMax == 'Y') {
      setModal('You have already reached the maximum number of UPI ID allowed. To add new UPI ID, please contact Customer Service with a justification.');
      setIsModalWarning(true);
    }
    else {
      setModal('Do you want to update account?');
      setIsModalWarningYesNo(true);
    }

  }
  const onDelete = () => {
    setIsModalWarningYesNo(false);
    setLoader(true);
    deleteBankUpi({
      mobileNo: mobileNum,
      mappingId: userDetails[0].USER_UPI_MAPPING_ID,
      deleteType: 'upi',
    }, newData.token)
      .then((data) => {
        if (data.status.status === "Y" && data.statusMsg.code === 0) {
          setUserDetails([]);
          setModal(data.statusMsg.msg);
          setIsModalSuccess(true);
          setUpi('');
          getUserInfo();
          setLoader(false);

        }
        else if (data.status.status === "N" && data.statusMsg.code === 1) {
          setModal(data.statusMsg.msg);
          setIsModalWarning(true);
          setLoader(false);

        }
        else if (data.status.status === "N" && data.statusMsg.code === -1) {
          setModal(data.statusMsg.msg);
          setIsModalError(true);
          setLoader(false);

        }
      })
      .catch((error) => {
        setLoader(false);

      });

  };
  useEffect(() => {
    if (newData.token == null) {
      navigate('/')
    }

    getUserInfo();
  }, [0]);
  return (
    <>
      <AppTracking pageName={window.location.pathname.replace(/\//g, '')} />
      <div className="content-wrapper responsive-wrapper">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 m-auto">
            <div className="DarkPanel">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <Bankdetails />
              </div>
            </div>
            {userDetails && userDetails?.length > 0 && (
              <>
                <section className="FormPanel pt-5 mb-1">
                  <h3>Saved UPI ID</h3>
                  <div className="card p-3 mb-1">
                    <div className="row">
                      <div className="col-8">
                        <p className="mb-0 mt-2">{userDetails[0]?.UPI_ID}</p>
                      </div>


                      <div className='col-4'>
                        <div className='text-end'>
                          <button
                            type=''
                            className='btn warning-btn'
                            onClick={deleteAccount}
                          >
                            {/* <Delete /> */}
                            Update UPI
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </section>
                <div className="row mt-3">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="info-panel">
                      <p>
                        {userInfo}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
            <section className="FormPanel py-4">
              <h3>UPI ID</h3>

              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                  <input
                    id='upiId'
                    name='upiId'
                    type='text'
                    className='form-control'
                    placeholder='Enter UPI ID'
                    value={upi}
                    maxLength={50}
                    disabled={userDetails.length > 0}
                    onChange={(event) => handleChangeUpi(event)}
                  />
                  {!resultUpi ? (
                    <div className='error text-danger text-start'>
                      {upiError}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 mb-2 mt-2">
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={handleSubmit}
                    disabled={!resultUpi}
                  >
                    Transfer
                  </button>
                </div>
              </div>


            </section>

          </div>
        </div>
      </div>
      <Modal className="success" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalSuccess} onHide={() => handleClose(1)} >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/accept.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(1)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="error" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalError} onHide={() => handleClose(2)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/cross.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(2)}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal >
      <Modal className="alert" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalWarning} onHide={() => handleClose(3)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/caution.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(3)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="alert" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalWarningYesNo} onHide={() => handleClose(4)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/caution.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="text-center">
              <Button variant="secondary" className="" onClick={() => onDelete()}>
                Yes
              </Button>
            </div>

          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="text-center">
              <Button variant="secondary" className="" onClick={() => handleClose(4)}>
                No
              </Button>
            </div>

          </div>
          {/* <Button variant="secondary" className="" onClick={() => handleClose(3)}>
            OK
          </Button> */}
        </Modal.Footer>
      </Modal>
      {loader && (
        <div id="overlay">
          <span className="loader"></span>
        </div>
      )}
      {loaderTrans && (
        <div className="loader1">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default UPIDetails;
